import { AlertsConstants } from "../actions/alerts";

const initialState: AlertsState = {
  alerts: [],
  feed: [],
  thresholds: [],
  loading: false,
  feedLoading: false,
  error: undefined,
};

const handlers: Partial<Record<string, (state: AlertsState, action: AlertsAction) => AlertsState>> = {
  [AlertsConstants.ALERTS_REQUEST]: (state) => ({ ...state, loading: true, error: undefined }),
  [AlertsConstants.ALERTS_SUCCESS]: (state, action) => ({
    ...state, loading: false,
    alerts: (action.payload as AlertsResponse).alerts,
  }),
  [AlertsConstants.ALERTS_FAILURE]: (state, action) => ({ ...state, loading: false, error: action.error }),

  [AlertsConstants.ALERT_CREATE_REQUEST]: (state) => ({ ...state, loading: true, error: undefined }),
  [AlertsConstants.ALERT_CREATE_SUCCESS]: (state, action) => ({
    ...state, loading: false,
    alerts: [action.payload as UserAlert, ...state.alerts],
  }),
  [AlertsConstants.ALERT_CREATE_FAILURE]: (state, action) => ({ ...state, loading: false, error: action.error }),

  [AlertsConstants.ALERT_UPDATE_REQUEST]: (state) => ({ ...state, loading: true, error: undefined }),
  [AlertsConstants.ALERT_UPDATE_SUCCESS]: (state, action) => {
    const updated = action.payload as UserAlert;
    return { ...state, loading: false, alerts: state.alerts.map((a) => a.id === updated.id ? updated : a) };
  },
  [AlertsConstants.ALERT_UPDATE_FAILURE]: (state, action) => ({ ...state, loading: false, error: action.error }),

  [AlertsConstants.ALERT_DELETE_REQUEST]: (state) => ({ ...state, loading: true, error: undefined }),
  [AlertsConstants.ALERT_DELETE_SUCCESS]: (state, action) => {
    const { id } = action.payload as { id: string };
    return { ...state, loading: false, alerts: state.alerts.filter((a) => a.id !== id) };
  },
  [AlertsConstants.ALERT_DELETE_FAILURE]: (state, action) => ({ ...state, loading: false, error: action.error }),

  [AlertsConstants.FEED_REQUEST]: (state) => ({ ...state, feedLoading: true, error: undefined }),
  [AlertsConstants.FEED_SUCCESS]: (state, action) => ({
    ...state, feedLoading: false,
    feed: (action.payload as FeedResponse).feed,
  }),
  [AlertsConstants.FEED_FAILURE]: (state, action) => ({ ...state, feedLoading: false, error: action.error }),

  [AlertsConstants.PATTERN_THRESHOLDS_REQUEST]: (state) => ({ ...state, loading: true }),
  [AlertsConstants.PATTERN_THRESHOLDS_SUCCESS]: (state, action) => ({
    ...state, loading: false,
    thresholds: (action.payload as PatternThresholdsResponse).thresholds,
  }),
  [AlertsConstants.PATTERN_THRESHOLDS_FAILURE]: (state, action) => ({ ...state, loading: false, error: action.error }),
};

export function alerts(state: AlertsState = initialState, action: AlertsAction): AlertsState {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
}
